'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.Contacts = Contacts;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _contact_reducer = require('./contact_reducer');

var _contact_reducer2 = _interopRequireDefault(_contact_reducer);

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _store = require('../../common/store');

var _store2 = _interopRequireDefault(_store);

var _services = require('..//../services');

var _contact = require('./contact');

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ReactDOM from 'react-dom'

var ContactList = function (_Component) {
    _inherits(ContactList, _Component);

    function ContactList(props) {
        _classCallCheck(this, ContactList);

        var _this = _possibleConstructorReturn(this, (ContactList.__proto__ || Object.getPrototypeOf(ContactList)).call(this, props));

        _this.getContactsList = function () {
            _this.props.dispatch((0, _contact_reducer.getContactInfoRequest)(_this.state.userData.user_id));
        };

        _this.contactNetworkStatusChange = function (contact_details) {
            _this.props.dispatch((0, _contact_reducer.contactNetworkStatusChange)(contact_details));
        };

        _this.loadContacts = function () {
            console.log("contacts props... : ", _this.props);
            if (_this.props.contacts && _this.props.contacts.contacts.length > 0) {
                var self = _this;
                var data = _this.props.contacts.contacts.map(function (contact) {
                    if (contact.id === self.state.userData.user_id) {
                        return '';
                    }
                    var key = Date.now() + "." + contact.id + "." + Math.floor(Math.random() * 8999 + 1000);
                    return _react2.default.createElement(_contact2.default, _extends({ key: key, contact: contact }, self.props));
                });
                _this.setState({
                    contactList: data,
                    shouldLoadContacts: false
                });
            } else {
                var _data = _react2.default.createElement(
                    'div',
                    { style: { height: "90%" } },
                    _react2.default.createElement(
                        'h4',
                        null,
                        'No contacts found '
                    )
                );
                _this.setState({
                    contactList: _data,
                    shouldLoadContacts: false
                });
            }
        };

        _this.state = {
            searchText: '',
            contactList: '',
            userData: null,
            shouldLoadContacts: false
        };
        return _this;
    }

    _createClass(ContactList, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var self = this;
            _services.user.get().then(function (res) {
                console.log("user get res..:", res);
                self.setState({
                    userData: res,
                    shouldLoadContacts: true
                });
                self.getContactsList();
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            if (window) {
                if (!window.jmdashboard) {
                    window.jmdashboard = [];
                }
                window.jmdashboard["contacts"] = this;
            } else {
                console.log("Error: window object not found, app not running in browser environment");
            }

            // if (this.dockerWidth !== this.dockerRef.offsetWidth) {
            //     this.dockerWidth = this.dockerRef.offsetWidth
            // }
        }
    }, {
        key: 'componentDidUpdate',


        // componentWillReceiveProps(nextProps) {
        //     console.log("inside comp will receive props... contacts.. : ", this.props.contacts)
        //     if(this.props.contacts.contactsFetchSuccess === true){
        //         this.loadContacts()        
        //     }
        // }

        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.contacts.contactsFetchSuccess === true && this.state.shouldLoadContacts) {
                this.loadContacts();
            }
            if (prevProps.contacts.contacts.length !== this.props.contacts.contacts.length) {
                this.loadContacts();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {}
    }, {
        key: 'render',
        value: function render() {
            // if(this.props.contacts.contactsFetchSuccess === true && !this.state.contactList){
            //     this.loadContacts()        
            // }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'box-body ', style: { backgroundColor: '#FFFFFF', overflow: 'auto' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'direct-chat-contacts-open' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'contacts-list' },
                            this.state.contactList
                        )
                    )
                )
            );
        }
    }]);

    return ContactList;
}(_react.Component);

ContactList.Store = ContactList.Store ? ContactList.Store : new _store2.default(Constants.NS_CONTACTS, { contactsState: _contact_reducer2.default });

function Contacts() {
    return window.jmdashboard["contacts"];
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        contacts: state.contactsState,
        user: state
    };
};

exports.default = (0, _store.connectWithStore)(ContactList.Store.getStore(), ContactList, mapStateToProps);


// WEBPACK FOOTER //
// ../chat/lib/components/contacts/contacts_list.js